import axios from 'axios';
import HttpHelper from '../../helpers/httpHelper';
import { buildQueryString, getHeaderDetail } from '../../helpers/utility';
require('dotenv').config();
const headerInfo = {};

/**
 * Read-only. The provider decides a verification and the member portal records it; this console
 * only reads the result, so there is no start, refresh, approve or reject to call.
 */
class KycAPI {
    static async GetApplications(query) {
        const filter = query || {};
        let url = process.env.REACT_APP_API_URL + '/kyc' + buildQueryString({
            page: filter.page,
            pageSize: filter.pageSize,
            search: filter.search,
            status: filter.status,
            fromDate: filter.fromDate,
            toDate: filter.toDate,
            memberId: filter.memberId,
        });
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    /**
     * The connection test. There is no vendor link to test from the console — this service holds no
     * vendor credentials — so what it verifies is the hop it owns: the signed ACCESS_KEY link to the
     * Customer Service, plus whatever that service reports as configured. Answers 200 even when the
     * link is down, carrying { ok: false, reason }, so a failure is rendered rather than thrown.
     */
    static async GetProvider(country) {
        let url = process.env.REACT_APP_API_URL + '/kyc/provider' + buildQueryString({
            country: country || undefined,
        });
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    /** One application in full, plus the member it belongs to: { application, member }. */
    static async GetApplication(id) {
        let url = process.env.REACT_APP_API_URL + '/kyc/detail/' + id;
        return HttpHelper.httpRequest(url, 'GET', headerInfo);
    }

    /**
     * One captured image, as raw bytes. Deliberately outside HttpHelper: this response is an image
     * rather than JSON, and a failure must leave a broken tile instead of raising the global 404 /
     * 500 toast. The bearer header still goes with it — the route is admin-authenticated, which is
     * why an <img src> pointed straight at the URL cannot work. Returns a Blob for URL.createObjectURL.
     */
    static async GetArtifact(id, artifactId) {
        let url = process.env.REACT_APP_API_URL + '/kyc/artifact/' + id + '/' + artifactId;
        const response = await axios.get(url, {
            headers: getHeaderDetail(headerInfo),
            responseType: 'blob',
        });
        return response.data;
    }
}

export default KycAPI;
